import { withShipmentSearch } from 'src/feathers/hooks';

export default {
  before: {
    all: [withShipmentSearch],
    find: [],
    get: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
